import React from 'react';
import { Card } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { BLOCK_LABELS } from './constants';

export default function BlockDetailsCard({ blockLabel, setBlockLabel, blockReason, setBlockReason }) {
  return (
    <Card className="p-4 space-y-4">
      <div>
        <Label className="text-xs uppercase font-bold text-muted-foreground mb-2 block">Block Reason Type</Label>
        <div className="flex flex-wrap gap-2">
          {BLOCK_LABELS.map((b) => {
            const Icon = b.icon;
            const active = blockLabel === b.value;
            return (
              <button
                key={b.value}
                type="button"
                onClick={() => setBlockLabel(b.value)}
                data-testid={`block-${b.value}`}
                className={`inline-flex items-center gap-2 px-4 py-2 rounded-full border text-sm font-semibold transition-colors ${
                  active
                    ? 'bg-slate-800 text-white border-slate-800'
                    : 'bg-white text-slate-700 border-slate-300 hover:bg-slate-50'
                }`}
              >
                <Icon className="w-4 h-4" /> {b.label}
              </button>
            );
          })}
        </div>
      </div>
      <div>
        <Label className="text-xs uppercase font-bold text-muted-foreground mb-1 block">Note (optional)</Label>
        <Textarea
          rows={2}
          placeholder="e.g. Court resurfacing scheduled"
          value={blockReason}
          onChange={(e) => setBlockReason(e.target.value)}
          data-testid="block-reason"
        />
      </div>
    </Card>
  );
}
